import React, { Component } from 'react';
import { Modal, Select, DatePicker, message, Spin } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const { Option } = Select;
const dateFormat = "YYYY-MM-DD";

// 校验value是否存在，且是options中的一项
const validateValueInOptions = (value, name, list) => {
    if (value) {
        const isExist = list.some(item => item.value == value);
        if (!isExist) {
            message.warning(`请选择正确的${name}`);
            return true;
        }
    } else {
        message.warning(`请选择${name}`);
        return true;
    }
    return false;
}

class RegisterPositive extends Component {
    state = {
        list: [],
        params: {},
        visible: false,
        loading: false,
    }

    show = (params) => {
        this.setState({
            params,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { params: { userId, positiveTime } } = this.state;
        if (!positiveTime) {
            message.warning('请选择转正时间');
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.setUserPositiveTime,
            data: {
                userId,
                positiveTime: positiveTime.slice(0, 10),
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    visible: false,
                    loading: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    getContent = () => {
        const { params } = this.state;
        const { positiveTime, userCompellation, employeeCode } = params;
        const newPositiveTime = positiveTime ? moment(positiveTime) : null;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">人员:</div>
                    <div className="item-right">
                            {`${userCompellation}[${employeeCode}]`}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">转正时间:</div>
                    <div className="item-right">
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 182 }}
                            format={dateFormat}
                            value={newPositiveTime}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "positiveTime")}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="登记转正信息"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="420px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

class RegisterPromotion extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        prevPositionOptions: [],
        curPositionOptions: [],
        departmentList: [],
        defaultDepartmentId: '',
        renderBeforePosition: true,
        renderAfterPosition: true,
    }

    componentDidMount() {
        this.queryDepartment();
    }

    show = (parentRecord, record) => {
        const { defaultDepartmentId } = this.state;
        const { userId, userCompellation, employeeCode } = parentRecord;
        const params = {
            userId,
            beforeDepartmentId: defaultDepartmentId,
            afterDepartmentId: defaultDepartmentId,
            ...(record || {}),
            employeeCode,
            userCompellation,
        };
        this.setState({
            params,
            isEdit: !!record,
            prevPositionOptions: [],
            curPositionOptions: [],
        }, () => {
            this.setState({
                visible: true,
            });
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    queryDepartment = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserDepartmentSelect,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                const defaultDepartmentId = (data ? data[0] : {})['enterpriseDepartmentId'];
                this.setState({
                    departmentList: data,
                    defaultDepartmentId,
                });
            },
        };
        $.sendRequest(options);
    }

    submit = () => {
        const {
            params: {
                userId,
                userPromotionId,
                promotionTime,
                promotionType,
                beforePositionId,
                afterPositionId,
            },
            prevPositionOptions,
            curPositionOptions,
        } = this.state;
        if (!promotionTime) {
            message.warning('请选择晋升时间');
            return;
        }
        if (!promotionType) {
            message.warning('请选择晋升类型');
            return;
        }
        if (validateValueInOptions(beforePositionId, '晋升前职位', prevPositionOptions)) {
            return;
        }
        if (validateValueInOptions(afterPositionId, '晋升后职位', curPositionOptions)) {
            return;
        }
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.saveUserPromotion,
            data: {
                userId,
                userPromotionId,
                promotionTime: promotionTime.slice(0, 10),
                promotionType,
                beforePositionId,
                afterPositionId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString, key) => {
        const { params } = this.state;
        params[key] = dateString;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        if (key == 'beforeDepartmentId') {
            params.beforePositionId = '';
            this.setState({
                prevPositionOptions: [],
                renderBeforePosition: false,
            }, () => {
                this.setState({ renderBeforePosition: true });
            });
        } else if (key == 'afterDepartmentId') {
            params.afterPositionId = '';
            this.setState({
                curPositionOptions: [],
                renderAfterPosition: false,
            }, () => {
                this.setState({ renderAfterPosition: true });
            });
        }
        this.setState({ params });
    }

    handleHighSearchInputFocus = () => {
        const { params: { hospitalId } } = this.state;
        if (!hospitalId) {
            message.warning('请先选择医院');
            return false;
        }
        return true;
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { params } = this.state;
        params[idName] = id;
        this.setState({
            params,
            [optionsName]: options,
        });
    }

    getContent = () => {
        const { isEdit, visible, params, departmentList, renderBeforePosition, renderAfterPosition } = this.state;
        const {
            promotionTime,
            promotionType,
            userCompellation,
            employeeCode,
            beforePositionId,
            beforePositionName,
            afterPositionId,
            afterPositionName,
            beforeDepartmentId,
            afterDepartmentId,
        } = params;
        const newPromotionTime = promotionTime ? moment(promotionTime) : null;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const departmentOptions = departmentList.map(i => <Option key={String(i.enterpriseDepartmentId)} title={i.enterpriseDepartmentName}>{i.enterpriseDepartmentName}</Option>)
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left" style={{width:'25%'}}>人员:</div>
                    <div className="item-right" style={{width:'75%'}}>
                            {`${userCompellation}[${employeeCode}]`}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{width:'25%'}}>{asterisk}晋升时间:</div>
                    <div className="item-right" style={{width:'75%'}}>
                        <DatePicker
                            placeholder="请选择"
                            style={{ width: 295 }}
                            format={dateFormat}
                            value={newPromotionTime}
                            onChange={(date, dateString) => this.handleDateChange(date, dateString, "promotionTime")}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{width:'25%'}}>{asterisk}晋升类型:</div>
                    <div className="item-right" style={{width:'75%'}}>
                        <Select
                            style={{ width: 295 }}
                            value={promotionType}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'promotionType')}
                        >
                            <Option value="BEAUTY_BUTTERFLY">美蝶</Option>
                            <Option value="WINGS_SPREAD">展翅</Option>
                            <Option value="NOMINATION_PROMOTION">提名晋升</Option>
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{width:'25%'}}>{asterisk}晋升前职位:</div>
                    <div className="item-right" style={{width:'75%'}}>
                        <Select
                            style={{ width: 130 }}
                            value={String(beforeDepartmentId)}
                            placeholder="请选择"
                            allowClear={false}
                            onChange={value => this.handleSelectChange(value, 'beforeDepartmentId')}
                        >
                            {departmentOptions}
                        </Select>
                        {
                            visible && renderBeforePosition &&
                            <HighSearchInput
                                isEdit={isEdit}
                                keyword='positionName'
                                style={{ width: 155, marginLeft: 10 }}
                                params={{ limit: 20, enterpriseDepartmentId: beforeDepartmentId }}
                                placeholder="输入职位名称自动检索"
                                url={API_URL.team.queryUserPositionSelect}
                                initValue={{ key: beforePositionId, label: beforePositionName }}
                                config={{ id: 'positionId', name: 'positionName' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'beforePositionId', 'prevPositionOptions')}
                            />
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{width:'25%'}}>{asterisk}晋升后职位:</div>
                    <div className="item-right" style={{width:'75%'}}>
                        <Select
                            style={{ width: 130 }}
                            value={String(afterDepartmentId)}
                            placeholder="请选择"
                            allowClear={false}
                            onChange={value => this.handleSelectChange(value, 'afterDepartmentId')}
                        >
                            {departmentOptions}
                        </Select>
                        {
                            visible && renderAfterPosition &&
                            <HighSearchInput
                                isEdit={isEdit}
                                keyword='positionName'
                                style={{ width: 155, marginLeft: 10 }}
                                params={{ limit: 20,  enterpriseDepartmentId: afterDepartmentId }}
                                placeholder="输入职位名称自动检索"
                                url={API_URL.team.queryUserPositionSelect}
                                initValue={{ key: afterPositionId, label: afterPositionName }}
                                config={{ id: 'positionId', name: 'positionName' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'afterPositionId', 'curPositionOptions')}
                            />
                        }
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '登记'}晋升信息`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="500px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export { RegisterPositive, RegisterPromotion };


// WEBPACK FOOTER //
// ./src/components/user/userInfo/PromotionModal.js